<template>
  <UnopenedLeadCard 
    @close="close"
    @open="open"
    :lead="lead"
  >
    <div><strong>Great news: for a limited time, this referral is FREE!</strong></div>
      
    <div class="mt-5">
      While this market is developing, leads are <strong>FREE</strong>, so grab as
      many as you want to connect with potential customers.
    </div>
    
    <div class="mt-5">
      Once pricing begins, most of what we collect goes back to the person who
      referred you to support high-quality referrals.
    </div>
  </UnopenedLeadCard>
</template>

<script>
import UnopenedLeadCard from './UnopenedLeadCard.vue'

export default {
  name: 'UnopenedLeadFree',

  components: { UnopenedLeadCard },

  props: {
    lead: {
      type: Object,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    open() {
      this.$router.push( { name: 'leads', params: { lead_id: this.lead.lead_id }})
    },
  },
}
</script>